export const defaultRegionId = 'london'
